import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Loader2 } from 'lucide-react';

/**
 * Redirects users to their appropriate home page based on role:
 * - Staff -> /my-day (Staff My Day view)
 * - Directors/Managers/Admin -> /operations (Operations Dashboard)
 */
const RoleBasedHome = () => {
  const { user, loading, isStaff, isAdmin } = useAuth();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Loader2 className="h-8 w-8 animate-spin text-primary" />
      </div>
    );
  }

  // Staff (non-admin) go to My Day
  if (isStaff && !isAdmin) {
    return <Navigate to="/my-day" replace />;
  }

  // Directors/Managers/Admin go to Operations Dashboard
  return <Navigate to="/operations" replace />;
};

export default RoleBasedHome;
